<template>
  <b-card class="border-0">
    <h4><b-icon icon="x-circle-fill"  class="mr-2"/><translate>Cancellacion Policy</translate></h4>
      <p><b><em v-translate>Each and every hotel has its own cancellation policy, depending on various criteria (season, early booking, etc). The general conditions are:</em></b></p>
      <ul>
          <li v-translate>If a booking is cancelled with more than 7 days before the arrival, no penalty;</li>
          <li v-translate>If a booking is cancelled between 7 and 4 days before the arrival, the hotel will charge 1 night as a penalty;</li>
          <li v-translate>If a booking is cancelled between 4 and 1 days before the arrival, the hotel will charge 2 nights as a penalty;</li>
          <li v-translate>If a booking is cancelled with 24 hours before the arrival, the hotel will charge the full amount of the reservation;</li>
          <li v-translate>In case of fraudulent use we reserve the right to block the access from our B2B page.</li>
      </ul>
  </b-card>
</template>

<script>
export default {
  name: 'emailAddress'
}
</script>

<style lang="scss" scoped>
  .modal-body h4 {
    font-size: 1.3rem;
    color: #293e97;
    border-bottom: 1px solid #ddd;
  }
</style>
